/**
 * 메뉴 설정 관리 API.
 * ROLE_MASTER 전용 — 트리 조회·CRUD·순서 저장.
 */
import { apiClient } from '@/shared/api/http-client';
import { createApiPath } from '@/shared/api/endpoints';

import type {
  AdminMenuDetail,
  AdminMenuTreeReorderRequest,
  AdminMenuTreeResponse,
  AdminMenuUpsertRequest,
} from '@/entities/menu/types';

export const menusService = {
  /** 전체 메뉴 트리 */
  getTree: async (): Promise<AdminMenuTreeResponse> => {
    const response = await apiClient.get(createApiPath.menus.list());
    return response.data;
  },

  getDetail: async (menuId: number): Promise<AdminMenuDetail> => {
    const response = await apiClient.get(createApiPath.menus.detail(menuId));
    return response.data;
  },

  create: async (body: AdminMenuUpsertRequest): Promise<AdminMenuDetail> => {
    const response = await apiClient.post(createApiPath.menus.list(), body);
    return response.data;
  },

  /** PATCH이지만 필드는 전부 전송한다 */
  update: async (
    menuId: number,
    body: AdminMenuUpsertRequest,
  ): Promise<AdminMenuDetail> => {
    const response = await apiClient.patch(
      createApiPath.menus.detail(menuId),
      body,
    );
    return response.data;
  },

  /** 204 — 본문 없음. 성공 후 트리를 재조회한다. */
  remove: async (menuId: number): Promise<void> => {
    await apiClient.delete(createApiPath.menus.detail(menuId));
  },

  /**
   * 전체 트리 순서·계층 저장.
   * 변경분만 보내면 안 되고 DB의 모든 메뉴 ID가 포함돼야 한다.
   */
  reorderTree: async (
    body: AdminMenuTreeReorderRequest,
  ): Promise<AdminMenuTreeResponse> => {
    const response = await apiClient.put(createApiPath.menus.tree(), body);
    return response.data;
  },
};
